import { ONBOARDING_MARKETING_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { GROUP_KEYS, FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { HAS_USED_HUBSPOT } from '../constants/queryParamConstants';
import { CRM_SIGNUP, MARKETING_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT, EXPERIENCE_NONE_PARAM, MARKETING_HUB_INTEREST } from '../constants/surveyConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { createMarketingOnboardingKey } from '../utils/onboardingKeyUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls';
import { BASELINE_FOR_NON_CRM_SIGNUPS_GATE } from '../constants/gateConstants';
const marketingExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingView
    };
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    gates: [BASELINE_FOR_NON_CRM_SIGNUPS_GATE],
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingView
    };
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    gates: [BASELINE_FOR_NON_CRM_SIGNUPS_GATE]
  }]
}, {
  // If the user has used HubSpot before, we want to send them to the Data Management flow.
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_HAS_USED_HUBSPOT),
      groupKey: GROUP_KEYS.marketerSep2020
    };
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    survey: {
      crmExperience: HAS_USED_HUBSPOT
    }
  }]
}, {
  // User with no CRM experience
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_NONE_PARAM),
      groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_MARKETING
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_NONE_PARAM,
    doNotSetGroupkey: true
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  // User with some CRM experience
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/marketing-tour/${portalId}/start-demo`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: createMarketingOnboardingKey(EXPERIENCE_HAS_USED_CRM_PARAM),
      groupKey: GROUP_KEYS.marketerSep2020
    };
  },
  redirectParams: {
    crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM
  },
  checks: [{
    signupType: MARKETING_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM
    }
  }]
}, // As Hub Interest is auto-filled for non-CRM Signup Types, this check goes
// last as it will prematurely match more specific checks above.
{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.MARKETING,
      onboardingKey: ONBOARDING_MARKETING_FREE,
      groupKey: FREE_GROUP_KEYS.freeMarketingView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: MARKETING_HUB_INTEREST
    }
  }]
}];
export default marketingExperiencesChecks;